
import Vue from "vue";

export default Vue.extend({
  name: "SummaryCard",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    changeText: {
      type: String,
      required: true
    },
    changeType: {
      type: String,
      default: "positive",
      validator: (value: string) => ["positive", "negative"].includes(value)
    },
    icon: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      default: "primary"
    },
    cardType: {
      type: String,
      default: ""
    }
  },
  methods: {
    isArabic() {
      return localStorage.getItem("locale") === "ar";
    }
  }
});
